import React, { useEffect, useCallback, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import BusinessCustomersActions from "../../Redux/transition/customers/business-customer.reducer";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { createHandleChange, trimInput, removeTrailingSpacesAndDashes } from "../../Components/CleanInputs";

const CustomerEdit = ({ displayBasic, onHide, id, state, setState }) => {

    const [formData, setFormData] = useState({
    });

    const [errors, setFieldErrors] = useState({
        name: '',
        customerNum: ''
    });

    const { t } = useTranslation("common");

    const toast = useRef(null);
    const handleChange = createHandleChange(setFormData, setFieldErrors, t);

    //redux state from store
    const updatingCustomer = useSelector((state) => state.businessCustomers.updating);
    const updateError = useSelector((state) => state.businessCustomers.updateError);
    const updateSuccess = useSelector((state) => state.businessCustomers.updateSuccess);
    const defMembership = useSelector((state) => state.defMembership.defMembership);

    const dispatch = useDispatch();
    const updateCustomer = useCallback((businessCustomerId, businessCustomer) => dispatch(BusinessCustomersActions.businessCustomerUpdateRequest(businessCustomerId, businessCustomer)), [dispatch]);
    const getEnterpriseCustomers = useCallback((businessId, options) => dispatch(BusinessCustomersActions.businessCustomerAllRequest(businessId, options)), [dispatch]);
    const getBusinessCustomerRecord = useCallback((businessCustomerId) => dispatch(BusinessCustomersActions.businessCustomerRecordRequest(businessCustomerId)), [dispatch]);
    const getSummaryCustomers = useCallback((businessId, query) => dispatch(BusinessCustomersActions.businessCustomerSummaryRequest(businessId, query)), [dispatch]);

    useEffect(() => {
        if (!updatingCustomer && state.updating && updateError) {
            showError();
        }
        if (!updatingCustomer && state.updating && updateSuccess) {
            showSuccess();
            setState((state) => { return { ...state, updating: false } })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateError, updatingCustomer, state.updating, updateSuccess]);

    const showSuccess = () => {
        toast.current.show({ severity: "success", summary: t("success"), detail: t("business_customers.success_detail"), life: 3000 });
    };

    const showError = () => {
        toast.current.show({ severity: "error", summary: t("business_customers.error_summary"), detail: t("business_customers.error_detail"), life: 3000 });
    };

    const renderFooter = (name) => {
        return (
            <div>
                <Button
                    style={{ background: "#D0021B", color: "white", border: 'none', fontFamily: "robotoCondensed", margin: "0rem 1rem 1rem 0rem" }}
                    label={t("business_customers.update")}
                    disabled={!state.name}
                    loading={updatingCustomer}
                    onClick={() => {
                        onSubmit();
                    }}
                    autoFocus
                />
            </div>
        );
    };

    const onSubmit = () => {
        if (!state.name || state.name.trim() === "" || formData.name === "") {
            setState((prev) => {
                return { ...prev, nameError: true };
            });
            return;
        } else {
            setState((prev) => {
                return { ...prev, nameError: false };
            });
        }

        const businessCustomer = {
            id: id,
            name: removeTrailingSpacesAndDashes(formData.name) || state.name,
            customerNum: removeTrailingSpacesAndDashes(formData.customerNum) || state.customerNum,
        };

        updateCustomer(id, businessCustomer);
        setState((prev) => {
            return { ...prev, updating: true };
        });

        // Trim values before sending or validating on submit
        // eslint-disable-next-line no-unused-vars
        const trimmedData = {
            firstName: trimInput(formData.firstName),
            lastName: trimInput(formData.lastName),
            customerNum: trimInput(formData.customerNum),
        };
    }

    return (
        <>
            <Toast
                ref={toast}
                onRemove={(message) => {
                    if (message.severity === "success") {
                        onHide();
                        getEnterpriseCustomers(defMembership.business.id, { sort: "addedOn,desc" });
                        getBusinessCustomerRecord(id);
                        getSummaryCustomers(defMembership.business.id);
                    }
                }}
            />
            <Dialog
                header={t("business_customers.edit_header")}
                visible={displayBasic}
                style={{ width: "350px" }}
                footer={renderFooter("displayBasic")}
                id="tier_dialog"
                className="tier_dialog"
                onHide={() => {
                    onHide();
                }}
            >
                <>
                    <div className="p-grid p-fluid" style={{ margin: "0 auto" }}>
                        <div className="edit_forms_div">
                            <div className="label_inputs">
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <label className="customer_labels">{t("common.name")}</label>
                                    <span style={{ color: "#d0021b", marginLeft: '0.2rem' }}>*</span>
                                </div>
                                <InputText
                                    error={state.nameError}
                                    required
                                    id="customer_id_required"
                                    name="lastName"
                                    label={t("common.name")}
                                    variant="outlined"
                                    defaultValue={state.name}
                                    value={formData.name}
                                    onChange={handleChange("name")}
                                    maxLength={50}
                                />
                                {state.nameError && <p className="character_error_name pt-1" >{t("common.error_name_required")}</p>}
                            </div>

                            <div className="label_inputs">
                                <label className="customer_labels">{t("business_customers.customer_ref")}</label><InputText
                                    id="customer_id_required"
                                    name="id"
                                    label={t("business_customers.customer_num")}
                                    variant="outlined"
                                    value={formData.customerNum}
                                    onChange={handleChange("customerNum")}
                                    maxLength={50}
                                    defaultValue={state.customerNum}
                                />
                                {errors.customerNum && <p className="character_error_subs">{errors.customerNum}</p>}
                            </div>
                        </div>
                    </div >
                </>
            </Dialog >
        </>
    )
}
export default CustomerEdit